<template>
  <div
    class="hero is-fullheight justify-center"
    style="
      background: #0f486d;
      background: linear-gradient(339deg, #0f486d 0%, rgba(66,203,182,1) 100%);
    "
  >
    <div class="columns is-centered">
      <div class="column is-3">
        <div class="card">
          <div class="card-header">
            <div class="column">
              <div class="is-size-5">
                Bienvenid@ a Pro Meritum
              </div>
            </div>
          </div>
          <div class="card-content">
            <div class="pb-20">
              Establece una contraseña para tu cuenta nueva.
              <br>
            </div>
            <ValidationObserver ref="observer" v-slot="{ passed }">
              <ValidationProvider
                vid="password"
                rules="password_complexity"
                name="Contraseña"
                v-slot="{ errors, valid }"
              >
                <b-field
                  label="Contraseña"
                  :type="{ 'is-danger': errors[0], 'is-success': valid }"
                  :message="errors[0]"
                >
                  <b-input
                    type="password"
                    password-reveal
                    v-model="form.password"
                    @focus="showRequirements = true"
                    @blur="showRequirements = false"
                    class="password-create" 
                  />
                  <PasswordRequirements
                    :customClass="'password-requirments-container-invite'"
                    :password="form.password " 
                    :showRequirements="showRequirements"
                  />
                </b-field>
              </ValidationProvider>
              <br>
              <div class="columns is-multiline">
                <div class="column is-12 has-text-right">
                  <b-button
                    type="is-primary"
                    :disabled="!passed"
                    @click="updatePassword"
                  >
                    Registrarse
                  </b-button>
                </div>
              </div>
            </ValidationObserver>
            <a href="/login">Ya cuento con contraseña</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PasswordRequirements from './PasswordRequirments.vue'

export default {
  name: 'AuthInvite',
  components: {
    PasswordRequirements
  },
  data () {
    return {
      form: {
        password: null
      },
      passwordRegex: /^(?=.*[A-ZÑ])(?=.*[a-zñ])(?=.*\d)(?=.*[!@#$%^&*()\-_=+{}[\]|\\:;"'<>,.?/~])[A-Za-zñÑ\d!@#$%^&*()\-_=+{}[\]|\\:;"'<>,.?/~]{12,128}$/
    }
  },
  computed: {
    invite () {
      const { invite } = this.$route.query
      return invite
    },
    isPasswordValid() {
      return this.passwordRegex.test(this.form.password);
    }
  },
  async beforeMount () {
    await this.verifyInvite()
  },
  methods: {
    async updatePassword () {
      const valid = await this.$refs.observer.validate()
      if(!valid) return

      try {
        const userSession = await this.$store.dispatch('createPasswordByInvite', this)
        if (userSession) 
          this.$router.push('/').catch(() => {})
      } finally {
        this.form.password = null
      }
    },
    async verifyInvite () {
      const userSession = await this.$store.dispatch('verifyInvite', this)

      if (userSession) 
        this.$router.push('/').catch(() => {})
    }
  }
}
</script>

<style scoped>
:deep(.password-requirments-container-invite){
  top: 0%;
}
</style>